const React = require('react');
const isAliBrowser = require('../../helper/common-helper').isAlipayBrowser();
const loadUrl = require('../../asset/images/load.gif');
require('./loading.scss');


module.exports = React.createClass({
  displayName: 'Loading',
  propTypes:{
    word: React.PropTypes.string,
  },
  getInitialState() {
    return {};
  },
  componentDidMount() {},
  render() {
    const { word } = this.props;
    return (
      <div className="loading-hover">
        {
          !isAliBrowser ?
            <div className="load-div">
              <div className="load-table-animation"></div>
              <p className="load-word">{word}</p>
            </div>
          :
            <div className="load-gif">
              <img src={loadUrl} alt="菊花转" className="load-pic" />
              <p className="load-word">{word}</p>
            </div>
        }
      </div>
    );
  },
});



// WEBPACK FOOTER //
// ./src/component/mui/loading.jsx